import React from 'react';
import { infoUrl } from './driftRemove';

// What to do with the ticked findings: update them, or remove them. Offered only where both make sense (canUpdate says whether a script can
// update any of them); the page shows nothing at all when only one thing is possible.
export function ActionChoice({ value, onChange, canUpdate, disabled }) {
  return (
    <select className="v2-select" aria-label="What to do" value={canUpdate ? value : 'remove'} disabled={disabled || !canUpdate} onChange={(e) => onChange(e.target.value)}>
      {canUpdate && <option value="update">Update</option>}
      <option value="remove">Remove</option>
    </select>
  );
}

// A link to a page about the app, opened in a new tab. Nothing when the app has no id. In a clickable row it must not also open the row.
export function InfoLink({ wingetId }) {
  const url = infoUrl(wingetId);
  if (!url) return null;
  return (
    <a className="v2-info" href={url} target="_blank" rel="noopener noreferrer" title="Opens a page about this app in a new tab" onClick={(e) => e.stopPropagation()}>Info</a>
  );
}
